module.exports = __webpack_public_path__ + "img/tradeRepublic.878277af.png";